import { Avatar, Card, CardHeader, Skeleton } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useTranslation } from "react-i18next";

export default function BalanceCard({
    Icon,
    title,
    value,
    loading
}) {
    const { t } = useTranslation()

    return (
        <Card sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
            <CardHeader
                avatar={
                    <Avatar aria-label="wallet" sx={{ width: 80, height: 80, bgcolor: grey[300] }}>
                        <Icon color="primary" sx={{ fontSize: 60 }} />
                    </Avatar>
                }
                title={title}
                titleTypographyProps={{
                    variant: "body1",
                    fontSize: 30,
                    fontWeight: 200,
                }}
                subheaderTypographyProps={{
                    fontWeight: "bold",
                    fontSize: 25,
                    color: "primary",
                }}
                subheader={
                    loading ? <Skeleton variant="text" /> : value
                }
            />
        </Card>
    )
}
